module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d48ffeabb5073f52a22ba417438e8ff4.png";